import Joi from '@hapi/joi'

export const CardSuspendRemarkSchema = {
    
    remark: Joi.string().invalid("").label("Remark").required().messages({
        "any.invalid": `Need a remark`,
        "any.required": `Remark Needed`
    })

}